import React from 'react';
import IconButtonActions from '../../DataTable/IconButtonActions';
import { ImportCustomColumn } from '../../../types/importCustomColumn';

interface ImportTableBodyProps {
  table: any;
  actions?: any;
  noDataMessage?: string;
}

const ImportTableBody: React.FC<ImportTableBodyProps> = ({
  table,
  actions,
  noDataMessage,
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row: any) => {
          prepareRow(row);

          return (
            <tr
              {...row.getRowProps({
                key: row.original.id ?? row.id, // ✅ key único basado en `id`
              })}
              className="dark:border-gray-700 hover:bg-gray-50 transition dark:hover:bg-graydark/40"
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as ImportCustomColumn<object>;

                return (
                  <td
                    {...cell.getCellProps({
                      key: cell.column.id, // ✅ key único por celda
                    })}
                    className="text-gray-900 dark:text-gray-200 px-4 py-5 text-[15px] leading-normal whitespace-pre-line break-words"
                  >
                    {column.customCell ? column.customCell(cell) : cell.render('Cell')}
                  </td>
                );
              })}

              {actions && (
                <td key={`actions-${row.original.id}`} className="px-4 py-2 text-center">
                  <div className="flex justify-center">
                    <IconButtonActions actions={actions} row={row.original} />
                  </div>
                </td>
              )}
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length + (actions ? 1 : 0)}
            className="text-gray-600 dark:text-gray-300 dark:border-gray-700 border-b py-4 text-center"
          >
            {noDataMessage || 'No hay datos disponibles.'}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ImportTableBody;
